(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jamuve-botanical-research"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jamuve-botanical-research')) {
    customElements.define('jamuve-botanical-research', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.start());
      }
      start() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.links = [...this.querySelectorAll('[data-jr-nav]')];
        this.items = [...this.querySelectorAll('[data-jr-item]')];
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-jr-nav]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const item = this.items.find((node) => '#' + node.id === link.getAttribute('href'));
          if (!item) return;
          event.preventDefault();
          item.focus({ preventScroll: true });
          item.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        this.update = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            let active = this.items[0];
            for (const item of this.items) {
              const offset = parseFloat(getComputedStyle(item).scrollMarginTop) || 0;
              if (item.getBoundingClientRect().top <= offset + 40) active = item;
            }
            for (const link of this.links) {
              const selected = active && link.hash === '#' + active.id;
              if (selected) link.setAttribute('aria-current', 'location');
              else link.removeAttribute('aria-current');
              if (selected && this.activeId !== active.id && matchMedia('(max-width: 989px)').matches) {
                const rail = link.parentElement;
                rail.scrollTo({ left: link.offsetLeft - rail.offsetLeft - 12, behavior: 'instant' });
              }
            }
            this.activeId = active?.id;
          });
        };
        window.addEventListener('scroll', this.update, { passive: true, signal });
        window.addEventListener('resize', this.update, { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          const item = this.items.find((node) => node.dataset.blockId === event.detail.blockId);
          item?.scrollIntoView({ block: 'start', behavior: 'instant' });
        }, { signal });
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamuve-selected-sources"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jamuve-selected-sources')) {
    customElements.define('jamuve-selected-sources', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.start());
      }
      start() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.groups = [...this.querySelectorAll('[data-jr-group-key]')];
        this.groups.forEach((group) => group.addEventListener('toggle', () => {
          if (group.open && this.dataset.singleOpen === 'true') this.closeOthers(group);
        }, { signal }));
        if (this.dataset.singleOpen === 'true') {
          const first = this.groups.find((group) => group.open);
          if (first) this.closeOthers(first);
        }
        document.addEventListener('click', (event) => {
          const link = event.target.closest('[data-jr-source-key]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const anchor = document.getElementById(link.hash.slice(1));
          if (!anchor || !this.contains(anchor)) return;
          const group = this.groups.find((node) => node.dataset.jrGroupKey === link.dataset.jrSourceKey);
          if (!group) return;
          event.preventDefault();
          this.openGroup(group, true);
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const block = [...this.querySelectorAll('[data-block-id]')].find((node) => node.dataset.blockId === event.detail.blockId);
          const group = block?.closest('details');
          if (group) this.openGroup(group, false);
          block?.scrollIntoView({ block: 'start', behavior: 'instant' });
        }, { signal });
        const openHash = () => {
          let id;
          try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
          const target = document.getElementById(id);
          if (!target || !this.contains(target)) return;
          const group = target.closest('details');
          if (group) this.openGroup(group, false);
        };
        window.addEventListener('hashchange', openHash, { signal });
        openHash();
      }
      closeOthers(selected) {
        this.groups.forEach((group) => { if (group !== selected) group.open = false; });
      }
      openGroup(group, focus) {
        if (this.dataset.singleOpen === 'true') this.closeOthers(group);
        group.open = true;
        if (focus) group.querySelector('summary').focus({ preventScroll: true });
        group.scrollIntoView({ block: 'start', behavior: focus && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
